import type {Result} from 'framework';
import type {ImagePreprocessError} from './image-preprocess.error';
import {getImagePreprocessor} from './runtime/select-image-preprocessor';
import type {PreparedImage, PreprocessImageOptions} from './types';

export {ImagePreprocessError} from './image-preprocess.error';
export {imageInputAccept} from './image-input-accept';
export {LLM_IMAGE_MAX_LONG_EDGE_PX, MAX_INPUT_BYTES, MEBIBYTE} from './constants';
export type {
  CropRegion,
  ImageContentHint,
  ImagePreprocessErrorCode,
  PreparedImage,
  PreprocessImageOptions,
} from './types';

/**
 * The one entry point every image upload goes through: orientation baked in,
 * long edge capped, photos as JPEG and graphics as PNG, HEIC converted, or the
 * original untouched when it already complies. Never throws; `aborted` is silent.
 */
export const preprocessImageForUpload = (
  file: File,
  options: PreprocessImageOptions,
): Promise<Result<PreparedImage, ImagePreprocessError>> =>
  getImagePreprocessor().preprocess(file, options);
